
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'
import { FormModel } from 'ant-design-vue'

import type { OrderItem as OrderItemType } from '@xt/client/entities/my-v2/types.d'

@Observer
@Component({
  components: {}
})
export default class Invoice extends Vue {
  @Ref('ruleForm') ruleForm: FormModel

  item: OrderItemType | null = null

  visible = false

  model = {
    titleType: '2', // 发票抬头类型 1个人，2公司
    title: '', // 发票抬头
    taxpayerCode: '', // 纳税人识别号
    targetEmail: '', // 邮箱
    orderNo: '', // 订单编号
    mediumType: '1', //发票介质 1电子发票，2纸质发票—(目前只有电子发票，前台可以不传)
    invoiceType: '2', // 发票类型 1普通发票，2增值税发票—（目前只有增值税发票，前台可以不传）
    content: '培训费' // 发票内容–(目前写死培训费，前台可以不传)
  }
  formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
  }
  rules = {
    title: { required: true, message: '请填写发票抬头', trigger: 'blur' },
    taxpayerCode: {
      required: true,
      message: '请填写纳税人识别号',
      trigger: 'blur'
    },
    targetEmail: [
      { required: true, message: '请填写邮箱', trigger: 'blur' },
      {
        validator: (rule, value, callback) => {
          if (!this.$Regulars.email.test(value)) {
            return callback(new Error('请输入正确的邮箱'))
          }
          return callback()
        },
        trigger: 'blur'
      }
    ]
  }

  get isCompany() {
    return lodash.eq(this.model.titleType, '2')
  }

  async onSubmit() {
    if (!this.item) return

    let isValidate = await this.ruleForm.validate()

    if (!isValidate) return

    const model = {
      ...this.model,
      targetEmail: this.model.targetEmail.trim()
    }

    await this.$store.$storeOrder.onOrderInvices(lodash.merge(model, { orderNo: this.item.raw.orderNo }))
    this.$msg(this.$EnumMessage.apply_invoice_success, 'success')

    this.$emit('success')
    this.closePop()
  }

  showPop(item: OrderItemType) {
    this.item = item
    this.visible = true
  }

  closePop() {
    this.visible = false

    this.$nextTick(() => {
      this.item = null
    })
  }

  noop() {}

  created() {}
  mounted() {}
  updated() {}
  destroyed() {
    this.item = null
  }
}
